/** @jsxImportSource @emotion/react */

export default function LogoCertX({ blanco = false, altura = "33px" }) {
  const colorBase = blanco ? "white" : "var(--negroCertx)";
  const colorX = "var(--amarilloCertx)";

  const fontSize =
    typeof altura === "string" && altura.endsWith("px")
      ? parseFloat(altura) * 0.85 + "px"
      : altura;

  return (
    <span
      css={{
        fontFamily: "'Montserrat', sans-serif",
        fontWeight: 700,
        fontSize: fontSize,
        letterSpacing: "-0.02em",
        lineHeight: 1,
        display: "inline-flex",
        alignItems: "center",
        userSelect: "none",
        textTransform: "lowercase"
      }}
    >
      <span css={{ color: colorBase }}>cert</span>
      <span
        css={{
          color: colorX,
          fontWeight: 800,
          textTransform: "uppercase",
          position: "relative",
          top: "-0.02em"
        }}
      >
        X
      </span>
      <span css={{ color: colorBase, marginLeft: "0.05em" }}>tech</span>
    </span>
  );
}
